// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"557":"3c8e78af","603":"61f5b2b0"}[chunkId] + ".chunk.css";
};